import React from 'react'
import SelectInput, { SelectOption } from '../../components/atoms/SelectInput'
import { useDispatch, useSelector } from 'react-redux'
import { SET_FILTERS } from 'dealer-reducers'
import { useTranslation } from 'react-i18next'
import Space from '../../components/atoms/Space'
import { COLORS, SPACE } from '../../theme'
import { RootReducer } from 'src/redux/rootReducer'
import View from '../atoms/View'
import Input from '../atoms/Input'

interface Props {
  showFilter: boolean
}

const prepareOptionsForYearSelect = (): SelectOption[] => {
  const years = Array.from(new Array(31), (e, i) => new Date().getFullYear() - i)
  return years.map((year) => ({ optionVal: year, optionLabel: year.toString() }))
}

const MotorbikeFilters = ({ showFilter }: Props): JSX.Element => {
  const currentTab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters[currentTab])
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const filterContainerWidth = 300

  if (!showFilter) {
    return <></>
  }
  return (
    <View>
      <View style={{ zIndex: 6 }}>
        <SelectInput
          label={t('filter_modal.motorbike_brand')}
          value={filters.motorbike_brand_id}
          options={t('filter_modal.brand_options', { returnObjects: true })}
          onChange={(val) => {
            dispatch(SET_FILTERS({ ...filters, motorbike_brand_id: val as number, tab: currentTab }))
          }}
        />
      </View>
      <Space y={2} />
      <Input
        dataTestId="motorbike-model-input"
        label={t('filter_modal.motorbike_model')}
        containerStyles={{
          marginLeft: SPACE,
          fontSize: 14,
          marginTop: SPACE,
          color: COLORS.darkGrey
        }}
        onChange={(e) => {
          dispatch(SET_FILTERS({ ...filters, model: e.target.value, tab: currentTab }))
        }}
        value={filters.model}
      />
      <Space y={2} />
      <View className="flex justify-between">
        <Input
          containerStyles={{
            marginLeft: SPACE,
            width: filterContainerWidth / 2 - 2 * SPACE,
            minWidth: 0,
            fontSize: 14,
            marginTop: SPACE,
            color: COLORS.darkGrey
          }}
          value={filters.total_mileage_from.toString()}
          onChange={(e) =>
            dispatch(
              SET_FILTERS({
                ...filters,
                total_mileage_from: e.target.value.length > 0 ? parseInt(e.target.value, 10) : '',
                tab: currentTab
              })
            )
          }
          label={t('filter_modal.milage_from')}
        />
        <Input
          containerStyles={{
            marginLeft: SPACE,
            width: filterContainerWidth / 2 - 2 * SPACE,
            minWidth: 0,
            fontSize: 14,
            marginTop: SPACE,
            color: COLORS.darkGrey
          }}
          value={filters.total_mileage_to.toString()}
          onChange={(e) =>
            dispatch(
              SET_FILTERS({
                ...filters,
                total_mileage_to: e.target.value.length > 0 ? parseInt(e.target.value, 10) : '',
                tab: currentTab
              })
            )
          }
          label={t('filter_modal.milage_to')}
        />
      </View>
      <Space y={2} />
      <View className="flex justify-between z-10">
        <View style={{ width: filterContainerWidth / 2 - SPACE }}>
          <SelectInput
            label={t('filter_modal.year_form')}
            value={filters.production_year_from}
            options={prepareOptionsForYearSelect()}
            onChange={(val) => {
              dispatch(SET_FILTERS({ ...filters, production_year_from: val as number, tab: currentTab }))
            }}
          />
        </View>
        <View style={{ width: filterContainerWidth / 2 - SPACE }}>
          <SelectInput
            label={t('filter_modal.year_to')}
            value={filters.production_year_to}
            options={prepareOptionsForYearSelect()}
            onChange={(val) => {
              dispatch(SET_FILTERS({ ...filters, production_year_to: val as number, tab: currentTab }))
            }}
          />
        </View>
      </View>
    </View>
  )
}

export default MotorbikeFilters
